import React from "react";
import SelectField from "../../../../components/SelectField";
import MultiSelect from "../../../../components/MultiSelect";
import styles from "./index.module.scss";
import { TemplateFormProps } from "../types";

const TemplateForm: React.FC<TemplateFormProps> = ({
    template,
    templateObject,
    index,
    state,
    onTemplateChange,
    onTabChange,
    onRemoveTemplate,
    getFilteredOptionsForTemplate,
    onSyncTemplateTabs
}) => {    
    // Sync template tabs with customTabs when template changes
    React.useEffect(() => {
        if (templateObject && templateObject.tabItems && template) {
            // Check if tabs are already synced to avoid unnecessary updates
            const existingTabs = state.customTabs?.filter(tab => tab.templateId === template) || [];
            const templateTabTitles = templateObject.tabItems.map(tab => tab.title).sort();
            const existingTabTitles = existingTabs.map(tab => tab.tabTitle).sort();
            
            // Only sync if the tabs are different
            if (JSON.stringify(templateTabTitles) !== JSON.stringify(existingTabTitles)) {
                onSyncTemplateTabs(template, templateObject.tabItems);
            }
        }
    }, [template, templateObject?.tabItems, onSyncTemplateTabs, state.customTabs]);

    // Get tabs from customTabs for this template
    const getTemplateTabs = () => {
        if (!state.customTabs) return [];
        return state.customTabs
            .filter(tab => tab && tab.tabTitle && tab.templateId === template)
            .map(tab => ({
                label: tab.tabTitle,
                value: tab.tabTitle
            }));
    };

    // Get selected tabs from state.customTabs for this template
    const getSelectedTabs = () => {
        if (!state.customTabs) return [];
        return state.customTabs
            .filter(tab => tab && tab.tabSelected && tab.templateId === template)
            .map(tab => tab.tabTitle);
    };

    return (
        <div className={`${styles.section} mb-3`}>
            <h2>Related Curricula Templates & Tabs</h2>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="col-12 col-md-10">
                    <SelectField
                        label="Template Name"
                        name="templateName"
                        options={getFilteredOptionsForTemplate(template).map((template) => ({ 
                            label: template.title, 
                            value: template._id 
                        }))}
                        value={template}
                        onChange={(_, value) => onTemplateChange(value, index)}
                        minHeight={55}
                    />
                </div>
                <button
                    type="button"
                    onClick={(e) => onRemoveTemplate(e, index)}
                    className={styles.clearButton}
                >
                    Clear
                </button>
            </div>

            {(state.templates && state.templates.length > 0 && template && templateObject) && (
                <div className="col-12 col-md-10">
                    <MultiSelect
                        label="Available Tabs"
                        options={getTemplateTabs()}
                        value={getSelectedTabs()}
                        name="tabs"
                        onChange={(name, selectedTabIds) => onTabChange(name, selectedTabIds, template)}
                        placeholder="Select tabs..."
                        minHeight={55}
                    />
                </div>
            )}
        </div>
    );
};

export default TemplateForm;
